import type { UrlParamDefinition } from './UrlParams'

/**
 * URL-параметры, специфичные для платформы Yandex.
 * Эти параметры передаются платформой Yandex при запуске игры.
 */
export const YANDEX_URL_PARAMS: readonly UrlParamDefinition[] = [
    {
        name: 'draft', //
        description: 'Параметр, указывающий на запуск черновика игры (`true` или `false`)',
        group: 'yandex',
    },
    {
        name: 'game_url', //
        description: 'URL-адрес игры на платформе (пример: `game_url=https://localhost:3000/...`)',
        group: 'yandex',
    },
    {
        name: 'sdk', //
        description: 'URL-адрес для загрузки Yandex SDK (пример: `sdk=/sdk/_/v2.js`)',
        group: 'yandex',
    },
    {
        name: 'origin', //
        description: 'Оригинальный домен платформы (например, `https://yandex.ru`)',
        group: 'yandex',
    },
    {
        name: 'app-id', //
        description: 'Идентификатор приложения в системе Yandex (пример: `app-id=101570`)',
        group: 'yandex',
    },
    {
        name: 'device-type', //
        description: 'Тип устройства пользователя (`desktop`, `mobile`, `tablet`)',
        group: 'yandex',
    },
] as const
